import { authMethod } from '../secure-portal/auth/Auth.constants';
import { Environment } from './environment.types';

const environment: Partial<Environment> = {
  apiBaseUrl: 'http://localhost:3000/api/',
  siteDomain: 'localhost',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  accessDeniedPath: '/access-denied',
  expires: 365,
  // set to `true` and `none` if devServer https config is enabled
  // to allow cookies within an iframe to save in browser for development environment.
  // NOTE: When testing with https enabled,
  // you have to remove cookies (logout) that were set before going back to http
  // as cookies with different attributes are not overwritten with Cookies.set().
  secure: false, // true
  sameSite: 'lax', // 'none'
  tinyApiKey: '28wr7ysrep8u469n6qqpzvzmn9uyye4phxcstpwrtdh6blk1',
  productConfig: {
    designOutput: {
      enableRiskAssessment: true
    }
  },
  // productConfig: {
  //   userNeed: {
  //     name: 'Business Requirement',
  //     idPrefix: 'BR',
  //     disableRelations: ['validations'],
  //     visibleJiraFields: [
  //       {
  //         title: 'Assignee',
  //         fieldKey: 'assignee',
  //         type: 'user'
  //       },
  //       {
  //         title: 'Priority',
  //         fieldKey: 'priority',
  //         type: 'text'
  //       }
  //     ]
  //   },
  //   designInput: {
  //     name: 'User Story',
  //     idPrefix: 'US',
  //     visibleJiraFields: [
  //       {
  //         title: 'Assignee',
  //         fieldKey: 'assignee',
  //         type: 'user'
  //       },
  //       {
  //         title: 'Priority',
  //         fieldKey: 'priority',
  //         type: 'text'
  //       }
  //     ]
  //   },
  //   designOutput: {
  //     name: 'Design Input',
  //     idPrefix: 'DIR',
  //     visibleJiraFields: [
  //       {
  //         title: 'Assignee',
  //         fieldKey: 'assignee',
  //         type: 'user'
  //       },
  //       {
  //         title: 'Priority',
  //         fieldKey: 'priority',
  //         type: 'text'
  //       }
  //     ]
  //   },
  //   validation: { disableRelations: ['userNeeds'] },
  //   designSpec: {}
  // },
  hazardConfig: {
    cause: {
      visibleJiraFields: [
        {
          title: 'Assignee',
          fieldKey: 'assignee',
          type: 'user'
        },
        {
          title: 'Progress',
          fieldKey: 'progress',
          type: 'progress'
        }
      ]
    },
    control: {
      visibleJiraFields: [
        {
          title: 'Assignee',
          fieldKey: 'assignee',
          type: 'user'
        },
        {
          title: 'Progress',
          fieldKey: 'progress',
          type: 'progress'
        }
      ]
    },
    action: {
      visibleJiraFields: [
        {
          title: 'Assignee',
          fieldKey: 'assignee',
          type: 'user'
        },
        {
          title: 'Progress',
          fieldKey: 'progress',
          type: 'progress'
        }
      ]
    }
  },
  changeOrderConfig: { useCustomFields: true, enableQualityChangeFields: true },
  authConfig: {
    methods: [authMethod.default, authMethod.google, authMethod.okta]
  },
  organizationConfig: { enabled: true }
};

export default environment;
